import Head from "next/head";
import * as React from "react";
// import DigitalRedeemPage from "../src/Digital/Redeem/DigitalProductRedeemPage";
import AuthCheckRedirect from "../src/Utility/Route/AuthCheckRedirect";
import dynamic from "next/dynamic";
const DigitalRedeemPage = dynamic(
  () => import("../src/Digital/Redeem/DigitalProductRedeemPage"),
  {
    ssr: false,
  }
);
export default function RedeemRoute() {
  return (
    <div>
      <Head>
        <meta property="og:title" content={"redeem"}></meta>
        <title>redeem</title>
      </Head>
      <DigitalRedeemPage></DigitalRedeemPage>
    </div>
  );
}
